import { useIntl } from 'react-intl';
import CustomTypeControlList from '../../components/CustomTypeControlList';
import { getColumns } from './columns';
import { getConcreteClassesStatistical } from '../../../../../services/redux/concreteClassesStatistical/actions';
import { useNavigate } from 'react-router-dom';

const StatisticalControlList = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <CustomTypeControlList
      columns={getColumns(intl)}
      normative="coe"
      entity="concreteClassesStatistical"
      title={intl.formatMessage({
        id: 'pages.quality.normative.statisticalControl.list.title',
      })}
      action={getConcreteClassesStatistical}
      onView={(c) => {
        navigate(`lotting/${c.name}`);
      }}
    />
  );
};

export default StatisticalControlList;
